import { render, staticRenderFns } from "./settlements-list.vue?vue&type=template&id=402b696c&scoped=true"
import script from "./settlements-list.vue?vue&type=script&lang=js"
export * from "./settlements-list.vue?vue&type=script&lang=js"
import style0 from "./settlements-list.vue?vue&type=style&index=0&id=402b696c&prod&lang=scss&scoped=true"
import style1 from "./settlements-list.vue?vue&type=style&index=1&id=402b696c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402b696c",
  null
  
)

export default component.exports